'use client';

import React from 'react';
import {
    CustomerContentScoreForm,
    CustomerContentScoreFormSuccessInline,
} from '@royalaholddelhaize/ah-customer-content-score-form';
import { Locale } from '@royalaholddelhaize/ah-web-core';

export const ContentScoreForm: React.FC<{
    id: string;
    topic: string;
    locale: Locale;
}> = ({ id, topic, locale }) => {
    const [success, setSuccess] = React.useState(false);

    if (success) {
        return <CustomerContentScoreFormSuccessInline locale={locale} />;
    }

    return (
        <CustomerContentScoreForm
            id={id}
            locale={locale}
            showTopicLabel={false}
            label="Wat vond je van dit antwoord?"
            inline
            onRatingChange={rating => {
                if (rating === 5) {
                    setSuccess(true);
                }
            }}
            onSuccess={() => {
                setSuccess(true);
            }}
            topic={topic}
        />
    );
};
